// Configuración de preguntas por área
export const questionSets = {
  TRISTEZA: [
    {
      id: 'tristeza_1',
      question: '¿Con qué frecuencia te sientes sin energía o motivación para realizar actividades diarias?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'tristeza_2',
      question: '¿Has notado una disminución del interés o placer en actividades que antes disfrutabas?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'tristeza_3',
      question: '¿Te cuesta concentrarte o tomar decisiones en tu día a día?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'tristeza_4',
      question: '¿Tienes pensamientos negativos recurrentes sobre ti mismo/a, tu vida o tu futuro?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'tristeza_5',
      question: '¿Has notado cambios significativos en tu apetito o peso?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'tristeza_6',
      question: '¿Sientes que no vales lo suficiente o que eres una carga para los demás?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'tristeza_7',
      question: '¿Te sientes solo/a aunque estés rodeado/a de gente?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'tristeza_8',
      question: '¿Has notado cambios en tus hábitos de sueño (dormir demasiado o muy poco)?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'tristeza_9',
      question: '¿Te sientes irritable o con menos paciencia de lo habitual?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'tristeza_10',
      question: '¿Te resulta difícil disfrutar del momento presente porque estás preocupado/a o triste?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    }
  ],
  
  ANSIEDAD: [
    {
      id: 'ansiedad_1',
      question: '¿Con qué frecuencia te sientes nervioso/a, ansioso/a o con los nervios de punta?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'ansiedad_2',
      question: '¿Te preocupas excesivamente por diferentes aspectos de tu vida?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'ansiedad_3',
      question: '¿Experimentas tensión muscular, inquietud o dificultad para relajarte?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'ansiedad_4',
      question: '¿Tienes dificultades para controlar las preocupaciones?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'ansiedad_5',
      question: '¿Has experimentado síntomas físicos como palpitaciones, sudoración, temblores o dificultad para respirar?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'ansiedad_6',
      question: '¿Evitas situaciones o lugares por miedo o ansiedad?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'ansiedad_7',
      question: '¿Tienes pensamientos recurrentes sobre posibles peligros o cosas que podrían salir mal?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'ansiedad_8',
      question: '¿Has notado cambios en tus hábitos alimenticios como comer demasiado o muy poco?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'ansiedad_9',
      question: '¿Te resulta difícil concentrarte por estar pensando en tus preocupaciones?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'ansiedad_10',
      question: '¿Te sientes irritable o tienes dificultad para controlar tu temperamento?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    }
  ],
  
  ESTRES: [
    {
      id: 'estres_1',
      question: '¿Con qué frecuencia te sientes agotado/a físicamente al final del día sin una razón aparente?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'estres_2',
      question: '¿Sientes que tienes demasiadas responsabilidades o tareas pendientes?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'estres_3',
      question: '¿Te cuesta desconectar o dejar de pensar en obligaciones cuando intentas relajarte?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'estres_4',
      question: '¿Experimentas dolores de cabeza, tensión muscular u otros malestares físicos relacionados con el estrés?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'estres_5',
      question: '¿Sientes que no tienes tiempo suficiente para ti mismo/a?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'estres_6',
      question: '¿Has notado que respondes con irritabilidad o impaciencia a situaciones cotidianas?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'estres_7',
      question: '¿Tienes dificultades para priorizar tareas o establecer límites?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'estres_8',
      question: '¿Has notado cambios en tus hábitos alimenticios como comer demasiado o muy poco?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'estres_9',
      question: '¿Te cuesta dormir bien por tener la mente ocupada con preocupaciones?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'estres_10',
      question: '¿Sientes que no estás a la altura de lo que se espera de ti?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    }
  ],
  
  RUPTURA_PAREJA: [
    {
      id: 'ruptura_1',
      question: '¿Con qué frecuencia piensas en tu ex pareja o en la relación pasada?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'ruptura_2',
      question: '¿Experimentas emociones intensas (tristeza, enfado, nostalgia) cuando recuerdas la relación?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'ruptura_3',
      question: '¿Evitas lugares, actividades o personas que te recuerdan a tu ex pareja?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'ruptura_4',
      question: '¿Te cuesta concentrarte en tu trabajo o estudios debido a pensamientos sobre la ruptura?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'ruptura_5',
      question: '¿Has perdido interés en actividades que antes disfrutabas?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'ruptura_6',
      question: '¿Te sientes inseguro/a o con miedo a volver a iniciar una relación?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'ruptura_7',
      question: '¿Revisas constantemente sus redes sociales o buscas información sobre su vida actual?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'ruptura_8',
      question: '¿Has notado cambios en tus hábitos de sueño o alimentación desde la ruptura?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'ruptura_9',
      question: '¿Tienes pensamientos de autocrítica o te culpas por lo ocurrido en la relación?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'ruptura_10',
      question: '¿Sientes que tu vida ha perdido sentido o dirección desde la ruptura?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    }
  ],
  
  AUTOESTIMA: [
    {
      id: 'autoestima_1',
      question: '¿Con qué frecuencia te criticas a ti mismo/a o te hablas negativamente?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'autoestima_2',
      question: '¿Te comparas constantemente con otras personas y sales perdiendo en la comparación?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'autoestima_3',
      question: '¿Temes expresar tus opiniones o necesidades por miedo al rechazo?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'autoestima_4',
      question: '¿Te cuesta aceptar cumplidos o reconocer tus logros?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'autoestima_5',
      question: '¿Evitas desafíos o nuevas oportunidades por miedo a fracasar?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'autoestima_6',
      question: '¿Sientes que no mereces amor, éxito o cosas buenas en tu vida?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'autoestima_7',
      question: '¿Te afectan profundamente las críticas o comentarios negativos?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'autoestima_8',
      question: '¿Te cuesta establecer límites con los demás?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'autoestima_9',
      question: '¿Sientes que debes ser perfecto/a para ser aceptado/a o querido/a?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'autoestima_10',
      question: '¿Te resulta difícil identificar tus fortalezas o cualidades positivas?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    }
  ],
  
  INSOMNIO: [
    {
      id: 'insomnio_1',
      question: '¿Con qué frecuencia tienes dificultades para quedarte dormido/a?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'insomnio_2',
      question: '¿Te despiertas durante la noche y te cuesta volver a dormirte?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'insomnio_3',
      question: '¿Te despiertas demasiado temprano por la mañana sin poder seguir durmiendo?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'insomnio_4',
      question: '¿Sientes que tu sueño no es reparador o que no descansas lo suficiente?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'insomnio_5',
      question: '¿Estás preocupado/a por tus problemas de sueño o sus consecuencias?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'insomnio_6',
      question: '¿Tus problemas de sueño afectan a tu rendimiento diario o estado de ánimo?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'insomnio_7',
      question: '¿Te sientes irritable o con bajo estado de ánimo debido a la falta de sueño?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'insomnio_8',
      question: '¿Tu mente se mantiene activa con pensamientos cuando intentas dormir?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'insomnio_9',
      question: '¿Recurres a medicación, alcohol u otras sustancias para poder dormir?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    },
    {
      id: 'insomnio_10',
      question: '¿Tienes ansiedad o miedo cuando se acerca la hora de dormir?',
      options: ['Casi nunca', 'A veces', 'A menudo', 'Siempre']
    }
  ]
};
